import { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { organizationExists } from "./api/Services";
import { MenuProvider } from "./contexts/MenuContext";

import AcceptedPaymentMethods from "./pages/acceptedpaymentmethods/AcceptedPaymentMethods";
import ArticleGroups from "./pages/articlegroups/ArticleGroups";
import Articles from "./pages/articles/Articles";
import Attributes from "./pages/attributes/Attributes";
import BranchOffices from "./pages/branchoffices/BranchOffices";
import Brands from "./pages/brands/Brands";
import BusinessRules from "./pages/businessrules/BusinessRules";
import CalendarPricings from "./pages/calendarpricings/CalendarPricings";
import CalendarPromotions from "./pages/calendarpromotions/CalendarPromotions";
import Campaigns from "./pages/campaigns/Campaigns";
import SendCampaign from "./pages/campaigns/sendcampaign/SendCampaign";
import SentCampaigns from "./pages/campaigns/sentcampaigns/SentCampaigns";
import SentCampaignBatchDetail from "./pages/campaigns/sentcampaigns/SentCampaignBatchDetail";
import Catalogue from "./pages/repositionorders/catalogue/Catalogue";
import CataloguePurchaseOrder from "./pages/purchaseorders/catalogue/Catalogue";
import Categories from "./pages/categories/Categories";
import ChangePassword from "./pages/changepassword/ChangePassword";
import ChatIa from "./pages/chatia/ChatIa";
import ClientLevels from "./pages/clientlevels/ClientLevels";
import Clients from "./pages/clients/Clients";
import ClientSegments from "./pages/clientsegments/ClientSegments";
import Clusters from "./pages/clusters/Clusters";
import Colours from "./pages/colours/Colours";
import Curves from "./pages/curves/Curves";
import Deposits from "./pages/deposits/Deposits";
import ForgotPassword from "./pages/forgotpassword/ForgotPassword";
import Goals from "./pages/goals/Goals";
import Home from "./pages/home/Home";
import Layout from "./components/layout/Layout";
import Login from "./pages/login/Login";
import NewAcceptedPaymentMethods from "./pages/acceptedpaymentmethods/NewAcceptedPaymentMethods/NewAcceptedPaymentMethods";
import NewArticle from "./pages/newarticle/NewArticle";
import NewArticleGroup from "./pages/articlegroups/newarticlegroup/NewArticleGroup";
import NewAttribute from "./pages/attributes/newattribute/NewAttribute";
import NewBranchOffice from "./pages/newbranchoffice/NewBranchOffice";
import NewBrand from "./pages/brands/newbrand/NewBrand";
import NewCategory from "./pages/categories/newcategory/NewCategory";
import NewClient from "./pages/clients/newclient/NewClient";
import NewClientLevel from "./pages/clientlevels/newclientlevel/NewClientLevel";
import NewClientSegment from "./pages/newclientsegment/NewClientSegment";
import NewCluster from "./pages/clusters/newcluster/NewCluster";
import NewColour from "./pages/newcolours/NewColour";
import NewCommercialDates from "./pages/parameters/commercial-dates/NewCommercialDate";
import NewCurve from "./pages/curves/newcurve/NewCurve";
import NewDeposit from "./pages/deposits/newdeposit/NewDeposit";
import NewPricing from "./pages/newpricing/NewPricing";
import NewPurchaseOrder2 from "./pages/newpurchaseorder2/NewPurchaseOrder2";
import NewRepositionOrder from "./pages/newrepositionorder/NewRepositionOrder";
import NewReward from "./pages/fidelity/rewards/newreward/NewReward";
import NewRewardType from "./pages/fidelity/rewardtype/newrewardtype/NewRewardType";
import NewCampaign from "./pages/campaigns/newcampaign/NewCampaign";
import NewSeason from "./pages/parameters/seasons/NewSeason";
import NewSupplierPaymentMethod from "./pages/supplierpaymentmethods/newsupplierpaymentmethod/NewSupplierPaymentMethod";
import NewSupplier from "./pages/newsupplier/NewSupplier";
import NewUser from "./pages/users/newuser/NewUser";
import NewVehicle from "./pages/vehicles/newvehicle/NewVehicle";
import NotFound from "./pages/notfound/NotFound";
import Parameters from "./pages/parameters/Parameters";
import Pricings from "./pages/pricings/Pricings";
import PricingDashboard from "./pages/pricings/dashboard/PricingDashboard";
import PricingTypes from "./pages/pricingtypes/PricingTypes";
import Promotions from "./pages/promotions/Promotions";
import PromotionTypes from "./pages/promotiontypes/PromotionTypes";
import PurchaseOrderDashboard from "./pages/purchaseorders/dashboard/PurchaseOrderDashboard";
import PurchaseOrders from "./pages/purchaseorders/PurchaseOrders";
import RecommendationsMockup from "./pages/fidelity/recomendations/RecommendationsMockup";
import RepositionOrderDashboard from "./pages/repositionorders/dashboard/RepositionOrderDashboard";
import RepositionOrders from "./pages/repositionorders/RepositionOrders";
import RequestDetail from "./pages/repositionorders/requests/RequestDetail";
import Requests from "./pages/repositionorders/requests/Requests";
import Rewards from "./pages/fidelity/rewards/Rewards";
import ActivationActions from "./pages/activation-actions/ActivationActions";
import ViewActivationAction from "./pages/activation-actions/view/ViewActivationAction";
import RewardTypes from "./pages/fidelity/rewardtype/RewardTypes";
import Signup from "./pages/signup/Signup";
import StockBreaks from "./pages/repositionorders/stockbreaks/StockBreaks";
import StockBreaksPurchaseOrders from "./pages/purchaseorders/stockbreaks/StockBreaks";
import StockMovementsWithTabs from "./pages/stockmovements/StockMovementsWithTabs";
import StockMovementImport from "./pages/stockmovements/StockMovementImport";
import Suppliers from "./pages/suppliers/Suppliers";
import Tickets from "./pages/tickets/Tickets";
import TicketImport from "./pages/tickets/TicketImport";
import PricingImport from "./pages/pricings/PricingImport";
import RewardImport from "./pages/fidelity/rewards/RewardImport";
import {
  ArticleSeasonImport,
  BranchOfficeImport,
  ClientImport,
  PaymentMethodImport,
  PointsMovementImport,
  PromotionImport,
  PurchaseOrderImport,
  RepositionOrderImport,
  SkuImport,
} from "./pages/imports/FileImports";
import ImportDashboard from "./pages/imports/ImportDashboard";
import UnitsMockup from "./pages/fidelity/units/UnitsMockup";
import NewAccumulationUnit from "./pages/fidelity/units/NewAccumulationUnit";
import UserRoles from "./pages/UserRoles/UserRoles";
import ValidateEmail from "./pages/validateemail/ValidateEmail";
import Vehicles from "./pages/vehicles/Vehicles";
import ViewAcceptedPaymentMethod from "./pages/acceptedpaymentmethods/viewacceptedpaymentmethod/ViewAcceptedPaymentMethod";
import ViewArticle from "./pages/viewarticle/ViewArticle";
import ViewArticleGroup from "./pages/articlegroups/viewarticlegroup/ViewArticleGroup";
import ViewBranchOffice from "./pages/viewbranchoffice/ViewBranchOffice";
import ViewBusinessUnit from "./pages/viewbusinessunit/ViewBusinessUnit";
import ViewCategory from "./pages/categories/viewcategory/ViewCategory";
import ViewClient from "./pages/viewclient/ViewClient";
import ViewClientLevel from "./pages/clientlevels/viewclientlevel/ViewClientLevel";
import ViewClientSegment from "./pages/viewclientsegment/ViewClientSegment";
import ViewCluster from "./pages/clusters/viewcluster/ViewCluster";
import ViewCommercialDate from "./pages/parameters/commercial-dates/viewcommercialdate/ViewCommercialDate";
import ViewCurve from "./pages/curves/viewcurve/ViewCurve";
import ViewDeposit from "./pages/viewdeposit/ViewDeposit";
import ViewPricing from "./pages/viewpricing/ViewPricing";
import ViewPromotion from "./pages/viewpromotion/ViewPromotion";
import ViewPurchaseOrder from "./pages/viewpurchaseorder/ViewPurchaseOrder";
import ViewRepositionOrder from "./pages/viewrepositionorder/ViewRepositionOrder";
import ViewReward from "./pages/fidelity/rewards/viewreward/ViewReward";
import ViewRewardType from "./pages/fidelity/rewardtype/viewrewardtype/ViewRewardType";
import ViewCampaign from "./pages/campaigns/viewcampaign/ViewCampaign";
import ViewSeason from "./pages/parameters/seasons/viewseason/ViewSeason";
import ViewSupplier from "./pages/viewsupplier/ViewSupplier";
import ViewTicket from "./pages/viewticket/ViewTicket";
import ViewVehicle from "./pages/vehicles/viewvehicle/ViewVehicle";
import DataScienceJobsMain from "./pages/datasciencejobs/DataScienceJobsMain";
import DataScienceJobsDashboard from "./pages/datasciencejobs/DataScienceJobsDashboard";
import DynamicDataScienceJobForm from "./pages/datasciencejobs/DynamicDataScienceJobForm";
import ViewDataScienceJob from "./pages/datasciencejobs/ViewDataScienceJob";

import { hasPermission, privilegesEnum } from "./helpers/PermissionHelper";

import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

import "./App.css";
import NewStockMovement from "./pages/stockmovements/newstockmovement/NewStockMovement";
import ArticlePricingDetail from "./pages/pricings/articledetail/ArticlePricingDetail";
import SimilarArticles from "./pages/commercial-intelligence/similar-articles/SimilarArticles";
import Recomendations from "./pages/purchaseorders/recomendations/Recomendations";
import FidelityDashboard from "./pages/fidelity/dashboard/FidelityDashboard";
import PromotionDashboard from "./pages/promotions/dashboard/PromotionDashboard";
import CommercialIntelligenceDashboard from "./pages/commercial-intelligence/dashboard/CommercialIntelligenceDashboard";
import ClientValidationStatistics from "./pages/promotions/statistics/ClientValidationStatistics";
import AdminWholesalers from "./pages/admin/wholesalers/AdminWholesalers";
import AdminOverview from "./pages/admin/overview/AdminOverview";
import AdminOrganizations from "./pages/admin/organizations/AdminOrganizations";
import ClientsWithStatistics from "./pages/commercial-intelligence/clients/ClientsWithStatistics";
import CommercialSummary from "./pages/commercial-analysis/summary/CommercialSummary";
import DailyControl from "./pages/commercial-analysis/daily-control/DailyControl";
import CategoryAnalysis from "./pages/commercial-analysis/categories/CategoryAnalysis";
import CategoryDetail from "./pages/commercial-analysis/categories/CategoryDetail";
import ProductAnalysis from "./pages/commercial-analysis/products/ProductAnalysis";
import ProductDetail from "./pages/commercial-analysis/products/ProductDetail";
import BrandAnalysis from "./pages/commercial-analysis/brands/BrandAnalysis";
import BrandDetail from "./pages/commercial-analysis/brands/BrandDetail";
import ChannelAnalysis from "./pages/commercial-analysis/channels/ChannelAnalysis";
import ChannelDetail from "./pages/commercial-analysis/channels/ChannelDetail";
import StoreAnalysis from "./pages/commercial-analysis/stores/StoreAnalysis";
import StoreDetail from "./pages/commercial-analysis/stores/StoreDetail";
import CommercialDateAnalysis from "./pages/commercial-analysis/commercial-dates/CommercialDateAnalysis";
import CommercialDateDetail from "./pages/commercial-analysis/commercial-dates/CommercialDateDetail";
import ProductMixAnalysis from "./pages/commercial-analysis/product-mix/ProductMixAnalysis";
import ClientAnalysis from "./pages/commercial-analysis/clients/ClientAnalysis";
import PromotionAnalysis from "./pages/commercial-analysis/promotions/PromotionAnalysis";
import PromotionDetail from "./pages/commercial-analysis/promotions/PromotionDetail";
import CampaignAnalysis from "./pages/commercial-analysis/campaigns/CampaignAnalysis";
import LoyaltyProgramAnalysis from "./pages/commercial-analysis/loyalty-program/LoyaltyProgramAnalysis";
import WholesaleAnalysis from "./pages/commercial-analysis/wholesale/WholesaleAnalysis";
import RecommendationRunsHistory from "./pages/recommendation-runs-history/RecommendationRunsHistory";
import { identifyClarityUser } from "./helpers/ClarityHelper";

function App() {
  const [subdomain, setSubDomain] = useState("");
  const [isValidSubdomain, setIsValidSubdomain] = useState(false);
  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState(localStorage.getItem("token"));
  const [isOrg, setIsOrg] = useState(false);

  useEffect(() => {
    handleValidateSubdomain();
    identifyClarityUser();
  }, []);

  const fullDomain = window.location.host;
  const appURL = process.env.REACT_APP_DOMAIN;
  const { pathname } = window.location;

  const handleValidateSubdomain: () => any = async () => {
    try {
      const domainArray = fullDomain.split(".");
      const appUrlArray = appURL?.split(".");

      let possibleOrgArray = domainArray.filter((x) => !appUrlArray?.includes(x));

      if (possibleOrgArray.length === 1) {
        const extractedSubdomain = possibleOrgArray[0];
        setSubDomain(extractedSubdomain);
        
        const exists = await organizationExists(extractedSubdomain);
        setIsValidSubdomain(exists);
      } else {
        setIsValidSubdomain(false);
      }
    } catch (error) {
      console.error("Error validating subdomain:", error);
      setIsValidSubdomain(false);
    } finally {
      setLoading(false);
    }
  };

  if (
    !loading &&
    !isOrg &&
    fullDomain != appURL &&
    !isValidSubdomain
  ) {
    return <NotFound />;
  }

  if (
    !loading &&
    !isOrg &&
    !token &&
    pathname !== "/validate" &&
    pathname !== "/register" &&
    pathname !== "/password/reset" &&
    pathname !== "/password/change"
  ) {
    return <Login />;
  }

  return (
    <div className="app">
      <Router>
        <MenuProvider>
        {((subdomain && isValidSubdomain) || subdomain === "") && !token && (
          <div>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Signup />} />
              <Route path="/password/reset" element={<ForgotPassword />} />
              <Route path="/password/change" element={<ChangePassword />} />
              <Route path="/validate" element={<ValidateEmail />} />
            </Routes>
          </div>
        )}
        {loading ? (
          <div className="ol-loading-spin">
            <Spin
              indicator={<LoadingOutlined className="ol-loading-spin-icon" />}
              delay={500}
            />
          </div>
        ) : (
          subdomain &&
          isValidSubdomain &&
          token && (
            <div>
              <Routes>
                <Route path="*" element={<NotFound />} />
                <Route path="/" element={<Layout />}>
                  <Route path="/ia" element={<ChatIa />} />
                  <Route path="/admin">
                    <Route path="overview" element={<AdminOverview />} />
                    <Route path="imports" element={<ImportDashboard />} />
                    <Route
                      path="organizations"
                      element={<AdminOrganizations />}
                    />
                    <Route
                      path="dashboard"
                      element={
                        <Navigate to="/commercial-analysis/summary" replace />
                      }
                    />
                    <Route
                      path="client-validation-stats"
                      element={<Navigate to="/admin/organizations" replace />}
                    />
                    <Route path="wholesalers" element={<AdminWholesalers />} />
                    <Route path="businessrules" element={<BusinessRules />} />
                    <Route path="goals" element={<Goals />} />
                    <Route path="parameters" element={<Parameters />} />
                    <Route
                      path="stockmovements"
                      element={<StockMovementsWithTabs />}
                    />
                    <Route
                      path="stockmovements/create"
                      element={<NewStockMovement />}
                    />
                    <Route path="tickets/import" element={<TicketImport />} />
                    <Route path="clients/import" element={<ClientImport />} />
                    <Route
                      path="clients/points-movements/import"
                      element={<PointsMovementImport />}
                    />
                    <Route path="articles/import" element={<SkuImport />} />
                    <Route
                      path="articles/seasons/import"
                      element={<ArticleSeasonImport />}
                    />
                    <Route
                      path="acceptedpaymentmethods/import"
                      element={<PaymentMethodImport />}
                    />
                    <Route path="promotions/import" element={<PromotionImport />} />
                    <Route
                      path="branchoffices/import"
                      element={<BranchOfficeImport />}
                    />
                    <Route
                      path="purchaseorders/import"
                      element={<PurchaseOrderImport />}
                    />
                    <Route
                      path="repositionorders/import"
                      element={<RepositionOrderImport />}
                    />
                    <Route path="rewards/import" element={<RewardImport />} />
                    <Route path="pricings/import" element={<PricingImport />} />
                    <Route
                      path="stockmovements/import"
                      element={<StockMovementImport />}
                    />
                    <Route
                      path="parameters/seasons/create"
                      element={<NewSeason />}
                    />
                    <Route
                      path="parameters/seasons/:id/view"
                      element={<ViewSeason />}
                    />
                    <Route
                      path="parameters/commercialdates/create"
                      element={<NewCommercialDates />}
                    />
                    <Route
                      path="parameters/commercialdates/:id/view"
                      element={<ViewCommercialDate />}
                    />
                    {hasPermission(privilegesEnum.READ_CLUSTERS) && (
                      <>
                        <Route path="clusters" element={<Clusters />}></Route>
                        <Route
                          path="clusters/:id/view"
                          element={<ViewCluster />}
                        ></Route>
                      </>
                    )}
                    {hasPermission(privilegesEnum.WRITE_CLUSTERS) && (
                      <Route path="clusters/create" element={<NewCluster />} />
                    )}

                    {hasPermission(privilegesEnum.READ_VEHICLES) && (
                      <>
                        <Route path="vehicles" element={<Vehicles />}></Route>
                        <Route
                          path="vehicles/:id/view"
                          element={<ViewVehicle />}
                        ></Route>
                      </>
                    )}
                    {hasPermission(privilegesEnum.WRITE_VEHICLES) && (
                      <Route path="vehicles/create" element={<NewVehicle />} />
                    )}

                    {hasPermission(privilegesEnum.READ_CURVES) && (
                      <>
                        <Route path="curves" element={<Curves />}></Route>
                        <Route
                          path="curves/:id/view"
                          element={<ViewCurve />}
                        ></Route>
                      </>
                    )}
                    {hasPermission(privilegesEnum.WRITE_CURVES) && (
                      <Route path="curves/create" element={<NewCurve />} />
                    )}

                    {(hasPermission(privilegesEnum.READ_USERS) ||
                      hasPermission(privilegesEnum.READ_ROLES)) && (
                      <Route path="users" element={<UserRoles />} />
                    )}
                    {hasPermission(privilegesEnum.WRITE_USERS) && (
                      <Route path="users/create" element={<NewUser />} />
                    )}
                    {hasPermission(
                      privilegesEnum.READ_ACCEPTED_PAYMENT_METHODS
                    ) && (
                      <>
                        <Route
                          path="acceptedpaymentmethods"
                          element={<AcceptedPaymentMethods />}
                        />
                        <Route
                          path="acceptedpaymentmethods/:id/view"
                          element={<ViewAcceptedPaymentMethod />}
                        />
                      </>
                    )}
                    {hasPermission(
                      privilegesEnum.WRITE_ACCEPTED_PAYMENT_METHODS
                    ) && (
                      <Route
                        path="acceptedpaymentmethods/create"
                        element={<NewAcceptedPaymentMethods />}
                      />
                    )}
                    {hasPermission(privilegesEnum.READ_BRANDS) && (
                      <Route path="brands" element={<Brands />} />
                    )}
                    {hasPermission(privilegesEnum.WRITE_BRANDS) && (
                      <Route path="brands/create" element={<NewBrand />} />
                    )}
                    {hasPermission(privilegesEnum.READ_CATEGORIES) && (
                      <Route path="categories" element={<Categories />} />
                    )}
                    {hasPermission(privilegesEnum.WRITE_CATEGORIES) && (
                      <Route
                        path="categories/create"
                        element={<NewCategory />}
                      />
                    )}
                    {hasPermission(privilegesEnum.READ_CATEGORIES) && (
                      <Route
                        path="categories/:id/view"
                        element={<ViewCategory />}
                      />
                    )}
                    {hasPermission(privilegesEnum.READ_DEPOSITS) && (
                      <>
                        <Route path="deposits" element={<Deposits />} />
                        <Route
                          path="deposits/:id/view"
                          element={<ViewDeposit />}
                        />
                      </>
                    )}
                    {hasPermission(privilegesEnum.READ_COLOURS) && (
                      <>
                        <Route path="colours" element={<Colours />} />
                      </>
                    )}
                    {hasPermission(privilegesEnum.WRITE_COLOURS) && (
                      <Route path="colours/create" element={<NewColour />} />
                    )}
                    {hasPermission(privilegesEnum.WRITE_DEPOSITS) && (
                      <Route path="deposits/create" element={<NewDeposit />} />
                    )}
                    {hasPermission(privilegesEnum.READ_BRANCH_OFFICES) && (
                      <>
                        <Route
                          path="branchoffices"
                          element={<BranchOffices />}
                        />
                        <Route
                          path="branchoffices/create"
                          element={<NewBranchOffice />}
                        />
                        <Route
                          path="branchoffices/:id/view"
                          element={<ViewBranchOffice />}
                        />
                      </>
                    )}
                    {hasPermission(privilegesEnum.READ_ATTRIBUTES) && (
                      <Route path="attributes" element={<Attributes />} />
                    )}
                    {hasPermission(privilegesEnum.WRITE_ATTRIBUTES) && (
                      <Route
                        path="attributes/create"
                        element={<NewAttribute />}
                      />
                    )}
                    {hasPermission(privilegesEnum.READ_PRICING_TYPES) && (
                      <Route path="pricingtypes" element={<PricingTypes />} />
                    )}
                    <Route path="promotiontypes" element={<PromotionTypes />} />
                    {hasPermission(privilegesEnum.READ_ARTICLES) && (
                      <>
                        <Route path="articles" element={<Articles />} />
                        <Route
                          path="articles/create"
                          element={<NewArticle />}
                        />
                        <Route
                          path="articles/:id/view"
                          element={<ViewArticle />}
                        />
                      </>
                    )}
                    {hasPermission(privilegesEnum.READ_SUPPLIERS) && (
                      <>
                        <Route path="suppliers" element={<Suppliers />} />
                        <Route
                          path="suppliers/create"
                          element={<NewSupplier />}
                        />
                        <Route
                          path="suppliers/:id/view"
                          element={<ViewSupplier />}
                        />
                      </>
                    )}
                    {hasPermission(privilegesEnum.READ_SUPPLIERS) && (
                      <Route
                        path="suppliers/payment/create"
                        element={<NewSupplierPaymentMethod />}
                      />
                    )}
                    {hasPermission(privilegesEnum.READ_BUSINESS_UNITS) && (
                      <Route
                        path="businessunit/:id/view"
                        element={<ViewBusinessUnit />}
                      />
                    )}

                    <Route
                      path="datasciencejobs"
                      element={<DataScienceJobsDashboard />}
                    />
                    <Route
                      path="datasciencejobs/faiss-indexes"
                      element={<DataScienceJobsDashboard />}
                    />
                    <Route
                      path="datasciencejobs/demand-forecast-models"
                      element={<DataScienceJobsDashboard />}
                    />
                    <Route
                      path="datasciencejobs/:jobType"
                      element={<DataScienceJobsMain />}
                    />
                    <Route
                      path="datasciencejobs/:jobType/create"
                      element={<DynamicDataScienceJobForm />}
                    />
                    <Route
                      path="datasciencejobs/:jobType/:id/edit"
                      element={<DynamicDataScienceJobForm isEdit={true} />}
                    />
                    <Route
                      path="datasciencejobs/:id/view"
                      element={<ViewDataScienceJob />}
                    />
                    <Route
                      path="faiss-indexes"
                      element={
                        <Navigate to="/admin/datasciencejobs/faiss-indexes" replace />
                      }
                    />
                  </Route>
                  <Route
                    path="/fidelity/recommendations"
                    element={<RecommendationsMockup />}
                  />
                  <Route
                    path="/fidelity/rewardtypes"
                    element={<RewardTypes />}
                  />
                  <Route
                    path="/fidelity/rewardtypes/create"
                    element={<NewRewardType />}
                  />
                  <Route
                    path="/fidelity/rewardtypes/:id/view"
                    element={<ViewRewardType />}
                  />
                  <Route
                    path="/fidelity/rewards/:id/view"
                    element={<ViewReward />}
                  />

                  <Route path="/fidelity/units" element={<UnitsMockup />} />
                  <Route path="/fidelity/units/create" element={<NewAccumulationUnit />} />
                  <Route path="/fidelity/rewards" element={<Rewards />} />
                  <Route
                    path="/fidelity/rewards/create"
                    element={<NewReward />}
                  />
                  {hasPermission(privilegesEnum.READ_CLIENT_LEVEL) && (
                    <>
                      <Route
                        path="/promotions/clientlevels"
                        element={<ClientLevels />}
                      ></Route>
                      <Route
                        path="/promotions/clientlevels/:id/view"
                        element={<ViewClientLevel />}
                      ></Route>
                      
                      <Route
                        path="/fidelity/clientlevels"
                        element={<ClientLevels />}
                      ></Route>
                      <Route
                        path="/fidelity/clientlevels/:id/view"
                        element={<ViewClientLevel />}
                      ></Route>
                    </>
                  )}
                  {hasPermission(privilegesEnum.WRITE_CLIENT_LEVEL) && (
                    <Route
                      path="/promotions/clientlevels/create"
                      element={<NewClientLevel />}
                    />
                  )}
                  {hasPermission(privilegesEnum.WRITE_CLIENT_LEVEL) && (
                    <Route
                      path="/fidelity/clientlevels/create"
                      element={<NewClientLevel />}
                    />
                  )}
                  {hasPermission(privilegesEnum.READ_CLIENTS) && (
                    <>
                      <Route path="/promotions/clients" element={<Clients />} />
                      <Route path="/fidelity/clients" element={<Clients />} />
                      {hasPermission(privilegesEnum.READ_TICKETS) && (
                        <>
                          <Route
                            path="/promotions/tickets"
                            element={<Tickets />}
                          />
                          <Route
                            path="/fidelity/tickets"
                            element={<Tickets />}
                          />
                          {/*<Route path="/tickets/create" element={<NewTicket />} />*/}
                          <Route
                            path="/promotions/tickets/:id/view"
                            element={<ViewTicket />}
                          />
                          <Route
                            path="/fidelity/tickets/:id/view"
                            element={<ViewTicket />}
                          />
                        </>
                      )}
                      <Route
                        path="/promotions/clients/create"
                        element={<NewClient />}
                      />
                      <Route
                        path="/fidelity/clients/create"
                        element={<NewClient />}
                      />
                      <Route
                        path="/promotions/clients/:id/view"
                        element={<ViewClient />}
                      />
                      <Route
                        path="/fidelity/clients/:id/view"
                        element={<ViewClient />}
                      />
                      <Route
                        path="/promotions/clientsegments"
                        element={<ClientSegments />}
                      />

                      <Route
                        path="/fidelity/clientsegments"
                        element={<ClientSegments />}
                      />
                      <Route
                        path="/promotions/clientsegments/create"
                        element={<NewClientSegment />}
                      />

                      <Route
                        path="/fidelity/clientsegments/create"
                        element={<NewClientSegment />}
                      />

                      <Route
                        path="/promotions/clientsegments/:id/view"
                        element={<ViewClientSegment />}
                      />

                      <Route
                        path="/fidelity/clientsegments/:id/view"
                        element={<ViewClientSegment />}
                      />
                    </>
                  )}
                  {hasPermission(privilegesEnum.READ_PRICINGS) && (
                    <>
                      <Route path="/pricings/dashboard" element={<PricingDashboard />} />
                      <Route path="/pricings" element={<Pricings />} />
                      <Route
                        path="/pricings/:id/view"
                        element={<ViewPricing />}
                      />
                      <Route
                        path="/pricings/calendar"
                        element={<CalendarPricings />}
                      />
                      {hasPermission(privilegesEnum.READ_ARTICLE_GROUP) && (
                        <Route
                          path="/pricings/articlegroups"
                          element={<ArticleGroups />}
                        />
                      )}
                      <Route
                        path="/pricings/articlegroups/create"
                        element={<NewArticleGroup />}
                      />
                      <Route
                        path="/pricings/articlegroups/:id/view"
                        element={<ViewArticleGroup />}
                      />
                      <Route path="/pricings/create" element={<NewPricing />} />
                      <Route
                        path="/pricings/articles/:id/detail"
                        element={<ArticlePricingDetail />}
                      />
                    </>
                  )}
                  {hasPermission(privilegesEnum.READ_PROMOTIONS) && (
                    <>
                      <Route
                        path="/promotions/calendar"
                        element={<CalendarPromotions />}
                      />
                      <Route
                        path="/promotions"
                        element={<Promotions />}
                      />
                      <Route
                        path="/promotions/:id/view"
                        element={<ViewPromotion />}
                      />
                    </>
                  )}
                  {hasPermission(privilegesEnum.WRITE_CAMPAIGNS) && (
                    <Route
                      path="/promotions/campaigns/create"
                      element={<NewCampaign />}
                    />
                  )}
                  {hasPermission(privilegesEnum.READ_CAMPAIGNS) && (
                    <>
                      <Route
                        path="/promotions/campaigns/:id/view"
                        element={<ViewCampaign />}
                      />
                      <Route
                        path="/promotions/campaigns/:id/sent"
                        element={<SentCampaigns />}
                      />
                      <Route
                        path="/promotions/campaigns/:id/sent/:batchId"
                        element={<SentCampaignBatchDetail />}
                      />
                      <Route
                        path="/promotions/campaigns/templates/:id/edit"
                        element={<Campaigns />}
                      />
                      <Route
                        path="/promotions/campaigns/templates/create"
                        element={<Campaigns />}
                      />
                      <Route
                        path="/promotions/campaigns/templates"
                        element={<Campaigns />}
                      />
                      <Route path="/promotions/campaigns" element={<Campaigns />} />
                    </>
                  )}
                  {hasPermission(privilegesEnum.SEND_CAMPAIGNS) && (
                    <Route
                      path="/promotions/campaigns/:id/send"
                      element={<SendCampaign />}
                    />
                  )}
                  <Route path="/promotions/statistics" element={<ClientValidationStatistics />} />

                  {hasPermission(privilegesEnum.READ_ARTICLE_GROUP) && (
                    <>
                      <Route
                        path="/promotions/articlegroups"
                        element={<ArticleGroups />}
                      />
                      <Route
                        path="/promotions/articlegroups/create"
                        element={<NewArticleGroup />}
                      />
                      <Route
                        path="/promotions/articlegroups/:id/view"
                        element={<ViewArticleGroup />}
                      />
                    </>
                  )}
                  {hasPermission(privilegesEnum.READ_PURCHASE_ORDERS) && (
                    <>
                      <Route path="/purchaseorders">
                        <Route
                          path="dashboard"
                          element={<PurchaseOrderDashboard />}
                        />
                        <Route path="management" element={<PurchaseOrders />} />
                        <Route path="create" element={<NewPurchaseOrder2 />} />
                        <Route
                          path=":id/view"
                          element={<ViewPurchaseOrder />}
                        />
                        <Route
                          path="stockbreaks"
                          element={<StockBreaksPurchaseOrders />}
                        />
                        <Route
                          path="catalogue"
                          element={<CataloguePurchaseOrder />}
                        />
                        <Route
                          path="recomendations"
                          element={<Recomendations />}
                        />
                        <Route path="requests" />
                      </Route>
                    </>
                  )}
                  {hasPermission(privilegesEnum.READ_REPOSITION_ORDERS) && (
                    <>
                      <Route path="/repositionorders">
                        <Route
                          path="dashboard"
                          element={<RepositionOrderDashboard />}
                        />
                        {/*<Route path="reports" />*/}
                        <Route
                          path="management"
                          element={<RepositionOrders />}
                        />
                        <Route path="stockbreaks" element={<StockBreaks />} />
                        <Route path="catalogue" element={<Catalogue />} />
                        <Route path="requests" element={<Requests />} />
                        <Route
                          path="requests/:id/detail"
                          element={<RequestDetail />}
                        />
                        <Route path="create" element={<NewRepositionOrder />} />
                        <Route
                          path=":id/view"
                          element={<ViewRepositionOrder />}
                        />
                      </Route>
                    </>
                  )}
                  <Route path="/" element={<Home />} />
                  <Route
                    path="/fidelity/dashboard"
                    element={<FidelityDashboard />}
                  />
                  <Route
                    path="/promotions/dashboard"
                    element={<PromotionDashboard />}
                  />
                  <Route path="/commercial-intelligence">
                    {hasPermission(privilegesEnum.READ_COMMERCIAL_DASHBOARD) && (
                      <Route path="dashboard" element={<CommercialIntelligenceDashboard />} />
                    )}
                    <Route path="opportunities/incentives" element={<Rewards />} />
                    <Route path="opportunities/incentives/create" element={<NewReward />} />
                    <Route path="opportunities/incentives/:id/view" element={<ViewReward />} />
                    {hasPermission(privilegesEnum.READ_PROMOTIONS) && (
                      <>
                        <Route path="opportunities/promotions" element={<Promotions />} />
                        <Route path="opportunities/promotions/:id/view" element={<ViewPromotion />} />
                      </>
                    )}
                    <Route
                      path="recommendation-runs"
                      element={<RecommendationRunsHistory />}
                    />
                    <Route path="opportunities/activation-actions" element={<ActivationActions />} />
                    <Route
                      path="opportunities/activation-actions/:id/view"
                      element={<ViewActivationAction />}
                    />
                    {hasPermission(privilegesEnum.READ_CAMPAIGNS) && (
                      <Route path="campaigns" element={<Campaigns />} />
                    )}
                    {hasPermission(privilegesEnum.WRITE_CAMPAIGNS) && (
                      <Route path="campaigns/create" element={<NewCampaign />} />
                    )}
                    {hasPermission(privilegesEnum.READ_CAMPAIGNS) && (
                      <>
                        <Route path="campaigns/:id/view" element={<ViewCampaign />} />
                        <Route path="campaigns/:id/sent" element={<SentCampaigns />} />
                        <Route path="campaigns/:id/sent/:batchId" element={<SentCampaignBatchDetail />} />
                      </>
                    )}
                    {/* Bright Actions: WhatsApp templates and send campaign routes hidden until ready */}
                    {hasPermission(privilegesEnum.READ_PRODUCT_ANALYSIS) &&
                      hasPermission(privilegesEnum.READ_ARTICLES) && (
                        <Route path="similar-articles" element={<SimilarArticles />} />
                      )}
                    {hasPermission(privilegesEnum.READ_CLIENTS) && (
                      <>
                        <Route path="clients" element={<ClientsWithStatistics />} />
                        <Route path="clients/create" element={<NewClient />} />
                        <Route path="clients/:id/view" element={<ViewClient />} />
                        <Route path="segments" element={<ClientSegments />} />
                        <Route path="segments/create" element={<NewClientSegment />} />
                        <Route path="segments/:id/view" element={<ViewClientSegment />} />
                      </>
                    )}
                    {hasPermission(privilegesEnum.READ_TICKETS) && (
                      <>
                        <Route path="tickets" element={<Tickets />} />
                        <Route path="tickets/:id/view" element={<ViewTicket />} />
                      </>
                    )}
                    {hasPermission(privilegesEnum.READ_CLIENT_LEVEL) && (
                      <>
                        <Route path="configuration/client-levels" element={<ClientLevels />} />
                        <Route path="configuration/client-levels/create" element={<NewClientLevel />} />
                        <Route path="configuration/client-levels/:id/view" element={<ViewClientLevel />} />
                      </>
                    )}
                    <Route path="configuration/reward-types" element={<RewardTypes />} />
                    <Route path="configuration/reward-types/create" element={<NewRewardType />} />
                    <Route path="configuration/reward-types/:id/view" element={<ViewRewardType />} />
                    <Route path="configuration/units" element={<UnitsMockup />} />
                    <Route path="configuration/units/create" element={<NewAccumulationUnit />} />
                    {hasPermission(privilegesEnum.READ_ARTICLE_GROUP) && (
                      <>
                        <Route path="configuration/article-groups" element={<ArticleGroups />} />
                        <Route path="configuration/article-groups/create" element={<NewArticleGroup />} />
                        <Route path="configuration/article-groups/:id/view" element={<ViewArticleGroup />} />
                      </>
                    )}
                  </Route>
                  <Route path="/commercial-analysis">
                    {hasPermission(privilegesEnum.READ_COMMERCIAL_SUMMARY) && (
                      <Route path="summary" element={<CommercialSummary />} />
                    )}
                    {hasPermission(privilegesEnum.READ_DAILY_CONTROL) && (
                      <Route path="daily-control" element={<DailyControl />} />
                    )}
                    {hasPermission(privilegesEnum.READ_CATEGORY_ANALYSIS) && (
                      <>
                        <Route path="categories" element={<CategoryAnalysis />} />
                        <Route path="categories/:id" element={<CategoryDetail />} />
                      </>
                    )}
                    {hasPermission(privilegesEnum.READ_PRODUCT_ANALYSIS) && (
                      <>
                        <Route path="products" element={<ProductAnalysis />} />
                        <Route path="products/:id" element={<ProductDetail />} />
                      </>
                    )}
                    {hasPermission(privilegesEnum.READ_BRAND_ANALYSIS) && (
                      <>
                        <Route path="brands" element={<BrandAnalysis />} />
                        <Route path="brands/:id" element={<BrandDetail />} />
                      </>
                    )}
                    {hasPermission(privilegesEnum.READ_CHANNEL_ANALYSIS) && (
                      <>
                        <Route path="channels" element={<ChannelAnalysis />} />
                        <Route path="channels/:id" element={<ChannelDetail />} />
                      </>
                    )}
                    {hasPermission(privilegesEnum.READ_STORE_ANALYSIS) && (
                      <>
                        <Route path="stores" element={<StoreAnalysis />} />
                        <Route path="stores/:id" element={<StoreDetail />} />
                      </>
                    )}
                    {hasPermission(privilegesEnum.READ_COMMERCIAL_DATE_ANALYSIS) && (
                      <>
                        <Route path="commercial-dates" element={<CommercialDateAnalysis />} />
                        <Route
                          path="commercial-dates/:id"
                          element={<CommercialDateDetail />}
                        />
                      </>
                    )}
                    {hasPermission(privilegesEnum.READ_PRODUCT_MIX_ANALYSIS) && (
                      <Route path="product-mix" element={<ProductMixAnalysis />} />
                    )}
                    {hasPermission(privilegesEnum.READ_CLIENT_ANALYSIS) && (
                      <Route path="clients" element={<ClientAnalysis />} />
                    )}
                    {hasPermission(privilegesEnum.READ_PROMOTION_ANALYSIS) && (
                      <>
                        <Route path="promotions" element={<PromotionAnalysis />} />
                        <Route path="promotions/:id" element={<PromotionDetail />} />
                      </>
                    )}
                    {hasPermission(privilegesEnum.READ_CAMPAIGN_ANALYSIS) && (
                      <Route path="campaigns" element={<CampaignAnalysis />} />
                    )}
                    {hasPermission(privilegesEnum.READ_LOYALTY_ANALYSIS) && (
                      <Route path="loyalty-program" element={<LoyaltyProgramAnalysis />} />
                    )}
                    {hasPermission(privilegesEnum.READ_WHOLESALE_ANALYSIS) && (
                      <Route path="wholesale" element={<WholesaleAnalysis />} />
                    )}
                  </Route>
                </Route>

                {/*<Route path="/register" element={<Signup />}></Route>*/}
              </Routes>
            </div>
          )
        )}
        </MenuProvider>
      </Router>
    </div>
  );
}
export default App;
